import { Box } from "@mui/material";

import { ISubject } from "interfaces/subject.interface";
import { IZone } from "interfaces/zone.interface";

import { ZoneNightReport } from "./ZoneNightReport";

type NightReportLandingProps = {
  zones: IZone[];
  selectedZones: IZone[];
  subjects: ISubject[];
};

export function NightReportLanding({
  zones,
  subjects,
  selectedZones,
}: NightReportLandingProps) {
  return (
    <Box
      sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 1 }}
    >
      {selectedZones.map((zone) => (
        <ZoneNightReport
          key={zone.id}
          subjectIDs={subjects
            .filter((s) => s.zone_id == zone.id)
            .map(({ id }) => id)}
          path={zone.path
            .split(".")
            .map((id) => zones.find((zone) => zone.id === id)?.name)
            .filter((zone) => zone !== undefined)}
        />
      ))}
    </Box>
  );
}
